import { Navigate, Outlet } from "react-router-dom";

const RoleBasedRoute = ({ allowedRoles }) => {
  const mgCd = localStorage.getItem("MgCd");

  // Determine the role based on MgCd length or value
  const role = mgCd?.length === 7
    ? "MR"
    : mgCd?.length === 6 || mgCd?.length === 5
    ? "SM"
    : mgCd === "Admi"
    ? "Admin"
    : null;

  // If role not matched or not allowed, redirect
  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to="/LoginPage" replace />;
  }

  return <Outlet />;
};

export default RoleBasedRoute;
